import styled from "styled-components";

export const ColumnHeader = styled.div`
  display: flex;
  padding: 1rem 1.5rem;
  justify-content: space-between;
`;
